(function () {
  function init(root) {
    const tabs = root.querySelectorAll("[data-bb-tab]");
    const panels = root.querySelectorAll(".bb-panel");
    if (!tabs.length || !panels.length) return;

    function activate(targetId) {
      tabs.forEach((t) => {
        const active = t.getAttribute("data-bb-tab") === targetId;
        t.classList.toggle("is-active", active);
        t.setAttribute("aria-selected", active ? "true" : "false");
      });
      panels.forEach((p) => p.classList.toggle("is-active", p.id === targetId));
    }

    tabs.forEach((btn) => {
      btn.addEventListener("click", () => activate(btn.getAttribute("data-bb-tab")));
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-bb-pitch-options]").forEach(init);
  });
})();
